module.exports = __webpack_public_path__ + "static/link-back-4602fda58b35d5c95edd7429d2efc512.png";